import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";

import "./AssignProductsToEngineer.css";
import { Form, Table } from "react-bootstrap";
import { getData, postData } from "../../../../utils/api";
import ModalSave from "../../ModalSave";
import ModalComplaintSave from "../../ModalComplaintSave";

const AssignProductsToEngineer = ({
  show,
  onHide,
  setErr,
  id,
  HistoryData,
  getAllData,
}) => {
  const [data, setData] = useState([]);


  const getAllProductData = async () => {
    {
      const res = await getData(
        `/complaint-management/preventive-maintainance/all-assign-products/${id}`
      );
      setData(res?.data);
    }
  };

  useEffect(() => {
    getAllProductData();
  }, [id]);

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const handleRemarkChange = async (id, value) => {
    const payload = {
      in_hand: value,
    };
    {
      const response = await postData(
        `/complaint-management/preventive-maintainance/change-product-status/${id}`,
        payload
      );

      if (response.success) {
        setShowModal({ code: response.code, message: response.message });
        setTimeout(() => {
          getAllProductData();
          setShowModal(0);
          // onHide();
        }, 1000);
      } else {
        setShowModal({ code: response.code, message: response.message });
        setTimeout(() => setShowModal(0), 1000);
      }
    }


    // Example: update state / call API
    // updateRemark(id, value)
  };

  return (
    <Modal
      className="common_modal Service_History_modal"
      centered
      aria-labelledby="contained-modal-title-vcenter"
      show={show}
      onHide={onHide}
      size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Product Status</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row mt-3">
          <div className="data table-responsive">
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Product</th>
                  <th>Engineer</th>
                  <th>Quantity</th>
                  <th>Product Status</th>
                  <th>Change product Status</th>
                </tr>
              </thead>

              <tbody>
                {data?.length > 0 ? (
                  data?.map((d, index) => (
                    <tr key={index}>
                      <td>{index + 1}.</td>

                      <td>{d?.product?.name}</td>
                      <td>{d?.user?.name}</td>
                      <td>{d?.quantity}</td>
                      <td>{d?.in_hand}</td>
                      <td>
                        {d?.in_hand == "Return" ? (
                          "Product Returned"
                        ) : (
                          <Form.Select
                            size="sm"
                            value={d?.in_hand || ""}
                            onChange={(e) =>
                              handleRemarkChange(d.id, e.target.value)
                            }>
                            <option value="">Select</option>
                            <option value="In Hand">In Hand</option>
                            <option value="Applied">Applied</option>
                            <option value="Return">Return</option>
                          </Form.Select>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={5}
                      style={{ textAlign: "center", padding: "10px" }}>
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>

        <div className="btn_holder"></div>
      </Modal.Body>
      <ModalComplaintSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </Modal>
  );
};

export default AssignProductsToEngineer;
